import * as React from 'react';
import * as styles from './styles.css';

import { NBSP } from '../../constants/symbols';

import { Text } from '../Text';
import { Container } from '../Container';
import { Form } from './Form';
import { ISendFeedbackParams } from '../../types/redux';

export interface IFeedbackProps {
  isLoading: boolean;
  isSendError: boolean;
  sendFeedback(params: ISendFeedbackParams): void;
  setDimensionsFeedback(top: number, height: number): void;
}

export class Feedback extends React.Component<IFeedbackProps, {}> {
  private containerRef = React.createRef<HTMLDivElement>();

  public componentDidMount() {
    if (this.containerRef.current) {
      this.props.setDimensionsFeedback(this.containerRef.current.offsetTop, this.containerRef.current.offsetHeight);
    }
  }

  public render() {
    return (
      <div ref={this.containerRef} className={styles['container']}>
        <Container>
          <div className={styles['title']}>
            <Text size="h2" color="white" bold>
              Получите доступ к аналитике уже сейчас
            </Text>
          </div>
          <div className={styles['description']}>
            <Text color="white">
              Оставьте контактные данные и расскажите, для каких задач планируете использовать аналитику. Мы{NBSP}
              свяжемся с{NBSP}вами, ответим на вопросы и поможем определиться с{NBSP}подходящим продуктом
            </Text>
          </div>
          <Form
            isLoading={this.props.isLoading}
            isSendError={this.props.isSendError}
            sendForm={this.props.sendFeedback}
          />
          <div className={styles['footer']}>
            <Text color="white" size="small">
              Нажимая кнопку «Отправить заявку», я{NBSP}подтверждаю своё согласие на обработку персональных данных
            </Text>
          </div>
        </Container>
      </div>
    );
  }
}
